<template>
  <div class="flex flex-col gap-y-3">
    <Form v-slot="{ values }">
      <Field
        validate-on-input
        validate-on-change
        validate-on-blur
        name="searchValue"
        v-slot="{ field, errors: errs }"
      >
        <TextInput
          :field="field"
          :errors="errs"
          :placeholder="$t('startWriteName')"
          class="w-full flex-1"
          @on-change="(event) => debounceSubmit(event)"
        />
      </Field>

      <div v-if="rows.length > 0">
        <DataTable :default-headers="['ArabicName', 'EnglishName', '']" :data-set="rows">
          <template #headerCell="{ label }">
            <span v-if="label == 'actions'"></span>
          </template>
          <template #cell="{ columnName, rowIndex }">
            <div v-if="columnName == 'actions'" class="w-32 h-full flex justify-center">
              <RouterLink
                :to="viewConfig"
                v-tippy="{ content: 'View' }"
                class="size-6 flex justify-center items-center rounded border-1 border-sky-400 bg-sky-600"
              >
                <FontAwesomeIcon :icon="faListAlt" class="text-white" />
              </RouterLink>
            </div>
          </template>
        </DataTable>
      </div>
    </Form>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import axiosInstance from '@/services'
import _ from 'lodash'
import { Field, Form } from 'vee-validate'
import { computed, ref, useAttrs } from 'vue'
import DataTable from '@/components/DataTable/index.vue'
import { faListAlt } from '@fortawesome/free-solid-svg-icons'
import { useAuthStore } from '@/stores/auth'
import client_lookups from '@/assets/json/clientLookups.json'

const attrs = useAttrs()
const authStore = useAuthStore()

const isLoading = ref(true)
const results = ref({})
const searchValue = ref()

const {
  application: { establishment }
} = client_lookups

const searchFor = computed(() => {
  const values = {
    2: 'FAMILY_MEMBER_RESI',
    4: 'FAMILY_MEMBER',
    5: 'DOMESTIC_HELPERS',
    6: 'WORK'
  }

  return values[attrs.searchCategoryId] ?? null
})

/**
 * TODO:
 * I don't know where the others are supposed to go.
 * I only know case 2, not establishment
 */
const viewConfig = computed(() => {
  console.log('attrs.searchCategoryId', attrs.searchCategoryId)
  let routeConfig
  switch (+attrs.searchCategoryId) {
    case 2:
      if (authStore.user.applicationId == establishment) {
        break
      } else {
        routeConfig = {
          path: '/individual/sponsored',
          query: {
            name: searchValue.value
          }
        }
      }
      break
    case 3:
      // routeConfig = {
      //   path: '/requests',
      //   query: {
      //     name: searchValue.value
      //   }
      // }
      break
    case 4:
      // routeConfig = {
      //   path: '/manageCitizenFamily',
      //   query: {
      //     name: searchValue.value
      //   }
      // }
      break
    default:
      break
  }

  return routeConfig
  // return {
  //   path: '/individual/sponsored',
  //   query: {
  //     name: searchValue.value
  //   }
  // }
})

const rows = computed(() => {
  if ((results.value?.collection ?? []).length === 0) return []

  return results.value.collection?.map((r) => {
    const { arabicNumber, englishName } = r
    return {
      ArabicName: arabicNumber,
      EnglishName: englishName,
      actions: ''
    }
  })
})

const debounceSubmit = _.debounce((e) => {
  onSubmit(e)
}, 300)

const onSubmit = async (event) => {
  isLoading.value = true
  searchValue.value = event.target.value

  const payload = {
    pageSize: 10,
    currentPage: 1,
    PersonName: event.target.value,
    SearchFor: searchFor.value,
    EstablishmentId: null
  }

  results.value = await axiosInstance.post('/api/sponsor/SponsoredAndFamilyMembers', payload)

  isLoading.value = false
}
</script>

<style lang="scss" scoped></style>
